import moment from 'moment/min/moment-with-locales'

function getDayString(date) {
  const m = moment(date);
  const today = moment().startOf("day");
  const tomorrow = moment().add(1, "day").startOf("day");
  const afterTomorrow = moment().add(2, "day").startOf("day");
  const dayAfterAfterTomorrow = moment().add(3, "day").startOf("day");

  let day = "today";

  if (m.isSameOrAfter(today) && m.isBefore(tomorrow)) {
    day =  "today";
  } else if (m.isSameOrAfter(tomorrow) && m.isBefore(afterTomorrow)) {
    day =  "tomorrow";
  } else if (m.isSameOrAfter(afterTomorrow) && m.isBefore(dayAfterAfterTomorrow)) {
    day =  "day_after_tomorrow";
  } 

  return day
}

function getFogHeightObject(date, prognoseFogHeights) {
  const dayString = getDayString(date)

  const fogHeights = {
    'alpen-voralpen': {
      fog_height: prognoseFogHeights['alpen-voralpen'][`fog_${dayString}`],
      fog_info: prognoseFogHeights['alpen-voralpen'][`fog_info_${dayString}`],
    },
    ostschweiz: {
      fog_height: prognoseFogHeights.ostschweiz[`fog_${dayString}`],
      fog_info: prognoseFogHeights.ostschweiz[`fog_info_${dayString}`],
    },
    tessin: {
      fog_height: prognoseFogHeights.tessin[`fog_${dayString}`],
      fog_info: prognoseFogHeights.tessin[`fog_info_${dayString}`],
    },
    westschweiz: {
      fog_height: prognoseFogHeights.westschweiz[`fog_${dayString}`],
      fog_info: prognoseFogHeights.westschweiz[`fog_info_${dayString}`],
    },
  }

  return fogHeights
}
export { getFogHeightObject, getDayString }
